import React, { createContext, useRef, useContext } from 'react';

// Create a context to hold the ref
const GlobalRefContext = createContext(null);

export const GlobalRefProvider = ({ children }) => {
  // Create the ref
  const globalRef:any = useRef(null);

  return (
    <GlobalRefContext.Provider value={globalRef}>
      {children}
    </GlobalRefContext.Provider>
  );
};

// Custom hook to use the global ref
export const useGlobalRef = () => {
  return useContext(GlobalRefContext);
};
